"use client";

import { useEffect } from "react";

// A deploy deletes the old build's chunks. Reload once; the timestamp guard
// stops a loop when the error isn't deploy skew.
const CHUNK_ERROR = /Failed to load chunk|Loading (CSS )?chunk|ChunkLoadError/i;
const RELOAD_KEY = "ft:chunk-reload-at";
const RELOAD_GUARD_MS = 10_000;

function reloadOnceForChunkError(error: unknown) {
  if (!(error instanceof Error)) return;
  if (!CHUNK_ERROR.test(`${error.name} ${error.message}`)) return;
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);
    if (Date.now() - last < RELOAD_GUARD_MS) return;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch {
    return; // storage blocked: no guard, so never auto-reload
  }
  window.location.reload();
}

// Renders outside IntlProvider (replaces the root layout): copy is hardcoded.
export default function GlobalError({ error }: { error: Error }) {
  useEffect(() => {
    reloadOnceForChunkError(error);
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          fontFamily: "system-ui, sans-serif",
          padding: 32,
          textAlign: "center",
        }}
      >
        <h1>Something went wrong</h1>
        <p>Folktale may have just been updated. Reloading usually fixes it.</p>
        <button type="button" onClick={() => window.location.reload()}>
          Reload
        </button>
      </body>
    </html>
  );
}
